import { User } from '@vsf-enterprise/sap-commerce-webservices-sdk';
import { Context } from '@vue-storefront/core';
import { LoadUserProps } from '../../../types';
import {CURRENT_USER_ID, getActiveUserId} from '../../../helpers';

export const loadUser = async (
  context: Context,
  props: LoadUserProps
): Promise<User> => {
  try {
    const {
      $sapcc: {
        config: { $cookies }
      }
    } = context;
    const user = getActiveUserId($cookies);
    if (user !== CURRENT_USER_ID) return null;

    return context.$sapcc.api.getUser(props);
  } catch (e) {
    return null;
  }
};
